module.exports = require("npm:json-schema-instantiator@0.3.0/index.js");